import { useQuery } from 'react-query';
import { PlaceholderSettingDto } from '../../../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';
import configQueryReactSimpleRequest from '../../../../config/configQuery';

const usePlaceholderQueryFn = () =>
    getProductReservationApi().placeholderSetting.placeholderSettingList()
        .then((response) => response.data);


const transformPlaceholdersNames = (data: PlaceholderSettingDto[] | null | undefined) =>
    data?.map((placeholder) => {
        return {
            ...placeholder,
            deelprojectId: {
                id: placeholder.deelprojectId,
                name: ""
            },
            organisation: {
                asiteCustomAttributeCode: placeholder.organisation,
                asiteCustomAttributeName: ""

            },
            documentType: {
                asiteCustomAttributeCode: placeholder.documentType,
                asiteCustomAttributeName: ""

            },
            phase: {
                asiteCustomAttributeCode: placeholder.phase,
                asiteCustomAttributeName: ""

            },
            workpackage: {
                asiteCustomAttributeCode: placeholder.workpackage,
                asiteCustomAttributeName: ""
            },
            targetFolder: {
                workspaceName: placeholder.targetFolder?.split("/")[0],
                fullPath: placeholder.targetFolder,
            },

        }
    })

const usePlaceholderQuery = () => {

    const placeholdersQuery = useQuery(['placeholders'], usePlaceholderQueryFn, {
        ...configQueryReactSimpleRequest,
        select: (content) => transformPlaceholdersNames(content)
    });
    return placeholdersQuery
};

export default usePlaceholderQuery;
